// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1rdxJ","productName":"Table_productName__2qQxv"};